const CHANNEL_NAME = 'sophia-ai-monitor'

export function initTabBeacon() {
  if (typeof BroadcastChannel === 'undefined') return

  const channel = new BroadcastChannel(CHANNEL_NAME)

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      channel.postMessage({ type: 'sophia-tab-focused', path: location.pathname })
    }
  })
}

export { CHANNEL_NAME }
